module.exports = __webpack_public_path__ + "img/appStoreWhite.0f3514a4.svg";